import React, { useState } from 'react';
import AdminPage from './AdminPage';
import MainHeader from './MainHeader';
import MainBody from './MainBody';
import MainFooter from './MainFooter';

/**
 * Top-level role splitter. Admin gets the new MUI AppShell (via AdminPage).
 * Clients still get the legacy Bootstrap header/body/footer until Phase D
 * refactors them. The session is set on login and read here.
 */
function MainPage() {
  const [selectedTab, setSelectedTab] = useState(0);
  const info = (() => {
    try { return JSON.parse(sessionStorage.getItem('companyInfo') || 'null'); }
    catch { return null; }
  })();

  if (info?.role === 'Admin') {
    return <AdminPage />;
  }

  return (
    <div>
      <MainHeader setSelectedTab={setSelectedTab} />
      <MainBody data={selectedTab} />
      <MainFooter />
    </div>
  );
}

export default MainPage;
